export default __webpack_public_path__ + "static/admin2-cdf71cf2ae2535d0f821177f76463aed.png";